import React from 'react'
import HomeLayout from './HomeLayout'

const Home = (props) => {
  return <HomeLayout showAlert={props.showAlert} />
}

export default Home
